import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatChipsModule } from '@angular/material/chips';
import { MatGridListModule } from '@angular/material/grid-list';
import { MediaTabGalleryComponent } from './media-tab-gallery.component';
import { VaActionMenuModule } from '@vendasta/uikit';
import { TranslateModule } from '@ngx-translate/core';
@NgModule({
  declarations: [MediaTabGalleryComponent],
  imports: [CommonModule, MatGridListModule, MatChipsModule, VaActionMenuModule, TranslateModule],
  exports: [MediaTabGalleryComponent],
})
export class MediaTabGalleryModule {}
